import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import Button from 'components/elements/buttons/Button';

import DashboardFormSection
  from 'components/dashboard/common/DashboardFormSection';
import AddPaymentProviderModal
  from 'components/dashboard/settings-content/commerce/modals/AddPaymentProviderModal';
import CommerceContactEmail
  from 'components/dashboard/settings-content/commerce/CommerceContactEmail';
import MyPaymentProvidersList
  from 'components/dashboard/settings-content/commerce/MyPaymentProvidersList';

import './CommerceSettings.css';

function CommerceSettings(props) {
  const { me } = props;
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <DashboardFormSection
      className="commerce-settings__component"
      header={t("COMMERCE SETTINGS")}
    >
      <div className="add-payment-provider">
        <div className="section-title">{t("Add your payment provider")}</div>
        <div className="text">
          {t("Add a supported payment provider to collect payments " +
             "from visitors of your HeyLink.me page. No more friction, " +
             "no more website shopping carts. Collect payments straight " +
             "from social: from donations to t-shirts & digital courses and more!")}
        </div>
        <Button
          small
          onClick={() => setModalOpen(true)}
        >
          + {t("Add Payment Provider")}
        </Button>
      </div>

      {/* Commerce Contact Email */}
      <CommerceContactEmail paymentProviders={me.payment_provider}/>

      {/* My PaymentProviders List */}
      <MyPaymentProvidersList paymentProviders={me.payment_provider}/>

      {/* Add Payment Provider Modal */}
      <AddPaymentProviderModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </DashboardFormSection>
  );
}

CommerceSettings.propTypes = {
  me: PropTypes.object,
};

CommerceSettings.propTypes = {
  me: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {},
)(CommerceSettings);
